<template>
  <section class="px-4 md:px-6 py-6 md:py-10 bg-surface-ground">
    <div class="text-center mb-10">
      <h2 class="text-3xl md:text-5xl font-bold">Build, Share and Bet</h2>
      <p class="text-lg md:text-2xl mt-2 mb-2">
        Easy and fast to build, share and place your bets.
      </p>
    </div>

    <div class="flex flex-wrap justify-center gap-4">
      <FeatureCard
        v-for="feature in features"
        :key="feature.title"
        v-animateonscroll="{ enterClass: feature.animationClass }"
        :title="feature.title"
        :points="feature.points"
        :image="feature.image"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import FeatureCard from '@/components/splash/howitworks2/FeatureCard.vue'
import AskCompareImg from '@/assets/images/how-to/how-to-compare-odds.png'
import BuildShareImg from '@/assets/images/how-to/how-to-share-bet-2.png'
import PlaceBetImg from '@/assets/images/how-to/how-to-place-bet.png'

const alternativeFade = window.innerWidth <= 990

interface Feature {
  title: string
  points: string[]
  image: string
  animationClass: string
}

const features = ref<Feature[]>([
  {
    title: 'Build',
    points: [
      'Type/say your selections',
      'Best odds will be displayed instantly from all available bookmakers',
      'Click on bookmaker logo to populate bet slip automatically on their site',
    ],
    image: AskCompareImg,
    animationClass: alternativeFade
      ? 'animate-enter fade-in-10 animate-duration-1000'
      : 'animate-enter fade-in-10 slide-in-from-b-20 animate-duration-1000',
  },
  {
    title: 'Share',
    points: [
      'Unique to Askodds you can share your selections with best odds via messaging apps for friends to edit',
      'Add selections, get the best odds, share back to all place a bet with best odd bookmaker or your favourite bookmaker',
      'Askodds sharing technology pre bet placements means no need to screenshot bets placed or message picks it can all be done instantly on one bet slip pre placement to be edited, and shared back for any friend to bet or change it',
    ],
    image: BuildShareImg,
    animationClass: alternativeFade
      ? 'animate-enter fade-in-10 animate-duration-1000'
      : 'animate-enter fade-in-10 slide-in-from-t-20 animate-duration-1000',
  },
  {
    title: 'Bet',
    points: [
      'Any version of bet can be placed at any time before or after sharing',
      "Tap the Go button to open bet on Bookmaker's app or site",
      'The bet will be loaded into the betslip',
      'If logged in, enter stake and place bet',
      'Return to Ask Odds for your next bet!',
    ],
    image: PlaceBetImg,
    animationClass: alternativeFade
      ? 'animate-enter fade-in-10 animate-duration-1000'
      : 'animate-enter fade-in-10 slide-in-from-b-20 animate-duration-1000',
  },
])
</script>
